export default
{
	data()
	{
		return {
			loading: false,
		}
	},

	methods:
	{
		applyLoading()
		{
			this.loading = true

			return this
		},

		removeLoading()
		{
			this.loading = false

			return this
		},
	},
}